export default __webpack_public_path__ + "static/media/wallet.4293133a.svg";